module.exports = __webpack_public_path__ + "media/images/gerb_minzdrava-209ba0f07ebf97e27ec9159ee18d772f.png";